<template>
    <div id="tst">
     
      <v-tooltip bottom>
        <v-btn slot="activator" dark icon small flat @click.native="dialog2 = !dialog2">
          <v-icon class="material-icons">person</v-icon>
        </v-btn>
          <span>Visualizar colaboradores</span>
      </v-tooltip>
     

      <v-dialog persistent v-if="dialog2"  v-model="dialog2" transition="dialog-bottom-transition">
        <v-toolbar dark class="headline darkBlue">
                  <v-toolbar-title>Colaboradores vinculados a {{nota.item.razao}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="dialog2 = false">
                    <v-icon>close</v-icon>
                  </v-btn>
          </v-toolbar>
        <v-card>
          
        <v-tooltip bottom>
            <v-btn slot="activator" outline color="black" text-color="white" dark class="d-inline-block" @click.native="showFormCadastrar('Colaborador')">
              <v-icon class="material-icons"  dark color="teal" style="padding-right: 10px;">person_add</v-icon>
              <small>Adicionar Colaborador</small>
            </v-btn>
          <span>Adicionar um novo colaborador a "{{nota.item.razao}}"</span>
        </v-tooltip>
        <article>
          <v-layout row justify-center>
            <v-dialog @keydown.esc="dialog = false" v-model="dialog" @keydown.enter="salvarDados()" max-width="700px" transition="dialog-bottom-transition">
              <v-card>
                <v-toolbar dark class="headline darkBlue">
                  <v-toolbar-title>Configuração do Colaborador</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click.native="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <article>
                  <v-subheader subheader class=".container"><h2>{{formEmp.titulo}}</h2></v-subheader>
                  <FormUsuario :displayFlex="'xs6 sm6 md6'" :create="true" :resetForm='resetForm' :getDadosForm="getDadosForm" @changResetForm="changResetForm($event)" @emitDadosForm="emitDadosForm($event)" ></FormUsuario>
                  <v-container grid-list-md text-xs-center>
                      <v-layout row wrap>
                        <v-flex xs6>
                            <v-btn block outline depressed small color="red" @click.native="dialog = false">Cancelar</v-btn>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn block depressed class="white--text" small color="teal" @click.native="salvarDados()">{{formEmp.btnSuccess}}</v-btn>
                        </v-flex>
                      </v-layout >  
                  </v-container >
                </article>
              </v-card>
            </v-dialog>
          </v-layout>
        </article>
        
          <v-container v-if="formEmp.show" class="panelFiltro">
            <div class="descTable">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 >
                      <h2 style="color:white; margin-left: 1em;"> {{formEmp.titulo}} </h2>
                    </v-flex>
                </v-layout >
            </div>
            <v-layout row wrap>
            </v-layout>
          </v-container>

        <div class="cardPerfil">  
          <div class="cardPerfil-body">
              <RenderTableNFe :empresa="this.nota.item" :conta="this.conta" :alert="this.alert" 
                :sendAttTable="this.sendAttTable" @attSendTable="attSendTable($event)" @emitEditEmp="emitEditEmp($event)" 
                :table="'usuario'" :arrayItems="nota.item.colaboradores" :attTableEmp="this.attTableEmp" @attTableEmp="attTableEmp($event)"></RenderTableNFe>
          </div>
        </div>
        </v-card>
      </v-dialog>
    </div>

</template>
<script>
import RenderTableNFe from "@/components/dataTable/RenderTableNFe.vue";
import FormUsuario from "@/components/conta/usuario/formUsuario/FormUsuario.vue";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import EmpresaService from "@/domain/conta/empresa/EmpresaService.js";
export default {
  props: ["conta", "empresa", "alert", "nota", "table"],
  components: {
    RenderTableNFe: RenderTableNFe,
    FormUsuario: FormUsuario
  },
  beforeCreate: function() {
    this.$options.components.RenderTableNFe = require("@/components/dataTable/RenderTableNFe.vue").default;
  },
  data() {
    return {
      dialog: false,
      dialog2: false,
      sendAttTable: false,
      resetForm: false,
      formEmp: { show: false, titulo: "", btnSuccess: "" },
      route: this.$router.history.current.path,
      empEdit: {},
      edit: false,
      getDadosForm: false,
      
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.$session.exists()) {
        if (this.$session.get("jwt").gravatarProfile != undefined) {
          this.avatarProfile =
            this.$session.get("jwt").gravatarProfile.thumbnailUrl + "?s=200";
        }
      }
    });
  },
  updated: function() {},
  watch: {
    dialog: function(newV, oldV) {
      if (!newV) {
        this.edit = newV;
      }
    }
  },
  computed: {},
  methods: {
    emitEditEmp($event) {
      this.formEmp.titulo = "Editar Empresa: ";
      this.formEmp.btnSuccess = "Salvar";
      this.empEdit = $event;
      this.edit = true;
      this.dialog = true;
    },
    showFormCadastrar(tipo) {
      this.formEmp.titulo = `Cadastro de ${tipo}:`;
      this.formEmp.btnSuccess = "Cadastrar";
      this.empEdit = {};
      this.edit = false;
      this.resetForm = true;
      this.dialog = true;
    },
    salvarDados() {
      this.getDadosForm = true;
    },
    changResetForm(value) {
      this.resetForm = value;
    },
    emitDadosForm(value) {
      let envDados = false;
      if (value != false) {
        this.dialog = false;
        this.edit = false;
        if (value.tipo.component == "empresa") {
          this.service = new EmpresaService(this.$http);
        } else if (value.tipo.component == "usuario") {
          this.service = new UsuarioService(this.$http);
        } else {
          throw new Error("Serviço de configuração não codificado");
        }

        envDados = true;
      } else {
        this.alert.snackAlert();
        this.alert.snack.text = "Verificamos que possuem campos com erros.";
        this.alert.snack.show = true;
      }
      this.getDadosForm = false;

      if (envDados) {
        let method;
        let id;
        let body = {};
        if (value.tipo.acao == "create") {
          id = this.conta.conta;
          method = "cadastrar";

          body["colaborador"] = value.dados;
          let empresas = [];
          empresas.push(this.nota.item._id);
          body["empresas"] = empresas;
        } else {
          body = value.dados;
          id = value.dados._id;
          method = "editar";
        }
        

        this.service[method](body, id).then(async function next(resp) {
          
          this.attTableEmp(resp);
        });
      }
    },
    attSendTable(value) {
      this.sendAttTable = value;
    },
    attTableEmp: async function(resp){
      this.service = new EmpresaService(this.$http);
      await this.service.getEmpresasConta(this.conta.conta).then(body => {
        this.table.arrayNotas = [];
            this.table.qnt_total_notas = body.empresas.length;
            this.table.qnt_total_notas = body.empresas.length + body.emprs_not_admin.length;
            let arrayEmpresas = body.empresas.concat(body.emprs_not_admin)
            this.table.setNota(
              this.table.arrayNotas,
              arrayEmpresas,
              body.faturamento
            ); 

            // this.table.arrayNotas = [];
            // this.table.qnt_total_notas = body.empresas.length;
            // this.table.setNota(
            //   this.table.arrayNotas,
            //   body.empresas,
            //   body.faturamento,
            //   this.table.pagination
            // );
            this.table.array_todas_notas = this.table.arrayNotas.slice();
            this.table.setPages(
              this.table.arrayNotas.length,
              this.table.pagination.rowsPerPage
            );
          });

          this.sendAttTable = true;
          this.alert.snackDanger();
          resp.body.message != undefined && resp.body.message.length != 0
            ? (this.alert.snack.text = resp.body.message)
            : this.alert.snack.text = resp.infoMessage.msg;
          if (resp.ok) {
            this.alert.snackSuccess();
          }
          this.alert.snack.show = true;
    }
  },
  beforeMount: function() {
    this.$nextTick(function() {});
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
#options {
  cursor: pointer;
}
.item:after {
  content: "";
  position: absolute;
  transition: all 0.5s linear;
  height: 2px;
  background-color: #25476a;
  width: 0%;
}
.item {
  transition: all 0.8s ease-in-out;
}
.item:hover {
  background-color: #eaeaea;
}
.item:hover:after {
  width: 100%;
  background-color: orangered;
}
#title {
  cursor: default;
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  padding: 6px;
  font-family: "Quicksand", sans-serif;
  color: #25476a;
}
#lista {
  padding: 20px;
}

#ico.v-btn {
  margin: 2px 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnUserEmpresa/BtnUserEmpresa.vue